import { State } from '.';
import { ProcedureType } from '../../models/procedure-type';

export const selectors = {
    getProcedureType: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<ProcedureType> => state.byId[id || ''],
    getProcedureTypeIds: (
        state: State
    ): number[] => state.allIds
};
